var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expedientes"},[_c('MenuOpcion',{attrs:{"titulo":_vm.titulo}}),_c('listaExped',{ref:"listaE",staticClass:"mt-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }